import {connect} from '@modifi/redux'

import TransportDocumentUploadDialog from './TransportDocumentUploadDialog'

const mapStateToProps = null

const mapDispatchToProps = {}

export const DIALOG_NAME = 'seller-trade-partner/upload-transport-document'
export default connect(mapStateToProps, mapDispatchToProps)(TransportDocumentUploadDialog)
